module.exports = "<p>\n  catalog works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/workflow-new/catalog/catalog.component.html
// module id = 922
// module chunks = 0